import { render, staticRenderFns } from "./PageForbidden.vue?vue&type=template&id=1ec01efe&scoped=true"
import script from "./PageForbidden.vue?vue&type=script&lang=js"
export * from "./PageForbidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec01efe",
  null
  
)

export default component.exports